// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles-tabs__3rJTr","tabs__item":"styles-tabs__item__19Zjg","tabs__item--selected":"styles-tabs__item--selected__1xkiy"};